import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable()
export class DontHaveAccessGuard implements CanActivate {
  constructor(private router: Router) {}

  account_id = JSON.parse(localStorage.getItem('currentUser')).id


  canActivate() {
    window.alert("You don't have access to this page");
    this.router.navigate([`/account/${this.account_id}/accountGoals`]);
    // this.router.navigate(["dashboard"]);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/guards/dont-have-access.guard.ts